// facebook弹窗登录
export function facebookLogin() {
  if (!process.client) {
    return
  }
  if (!window.firebase) return Promise.reject(null)
  var provider = new firebase.auth.FacebookAuthProvider()
  return new Promise((resolve, reject) => {
    firebase
      .auth()
      .signInWithPopup(provider)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

// facebook重定向方式登录
export function facebookLoginRedirect() {
  if (!process.client) {
    return
  }
  if (window.firebase && window.firebase.auth) {
    const provider = new firebase.auth.FacebookAuthProvider()
    firebase.auth().signInWithRedirect(provider)
  }
}

// 获取facebook重定向方法登录后的用户信息
export function getFacebookLoginUserInfo() {
  if (window.firebase && window.firebase.auth) {
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .getRedirectResult()
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
}
